import type { FigureStatus, LoanRecordStatus } from '@/types';

const FIGURE_STATUS_LABELS: Record<FigureStatus, string> = {
  projected: 'Projected',
  actual_lic: 'LIC Confirmed',
  reconciled: 'Reconciled',
};

export function StatusBadge({ status }: { status: FigureStatus }) {
  return <span className={`badge badge-${status}`}>{FIGURE_STATUS_LABELS[status]}</span>;
}

const LOAN_STATUS_LABELS: Record<LoanRecordStatus, string> = {
  draft_expected: 'Draft / Expected',
  lic_confirmed: 'LIC Confirmed',
};

/**
 * `label` / `isDraft` let a caller show a derived status (e.g. "Sanctioned ·
 * Partially disbursed") — see getLoanStatusLabel(). Without them the stored
 * status is shown exactly as before.
 */
export function LoanStatusBadge({ status, label, isDraft }: { status: LoanRecordStatus; label?: string; isDraft?: boolean }) {
  const draft = isDraft ?? status === 'draft_expected';
  const className = draft ? 'badge-draft' : 'badge-reconciled';
  return <span className={`badge ${className}`}>{label ?? LOAN_STATUS_LABELS[status]}</span>;
}
